const TOKEN_KEY = 'teusc_admin_token'

/** 读取本地 Token */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/** 持久化 Token */
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

/** 清除 Token */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}
